export const get_init_locale = () => {
    const AVAILABLE_locale = ['tw', 'en' ]
    const lang = get_query_string_lang()
    
    if (AVAILABLE_locale.includes(lang)) {
        return control_locale_from_query_string(lang)
    }

    if (get_from_localstorage()) {
        return get_from_localstorage()
    }

    return 'tw'
}

const get_query_string_lang = () => {
    const query_string = location.search.replace('?', '')
    if (query_string) {
        const search_params = new URLSearchParams(query_string);
        return search_params.get("lang")
    }

    return ''
}

const control_locale_from_query_string = (lang) => {
    localStorage.setItem('locale', lang)
    return lang
}

const get_from_localstorage = () => {
    return localStorage.getItem('locale') || ''
}